import React, { useCallback } from 'react'
import { BtnV2, Loader, l } from '@manychat/manyui'

import { useAppDispatch } from 'reduxTyped'
import { FlowPickerSimulator } from 'apps/flowPicker/components/FlowPickerPreviewSimulator/FlowPickerSimulator'
import { useFlowPickerPreview } from 'apps/flowPicker/hooks/useFlowPickerPreview'
import { FlowPickerActions } from 'apps/flowPicker/store'
import { useFlowValidation } from 'common/hooks/useFlowValidation'
import { FsFlow } from 'shared/api/requests/cms/schemas'

export interface FlowPickerPreviewContentProps {
  lastSelectedFlowId: string
  cmsFlow: FsFlow
}

export function FlowPickerPreviewContent({
  lastSelectedFlowId,
  cmsFlow,
}: FlowPickerPreviewContentProps) {
  const dispatch = useAppDispatch()

  const { isValid, errorMessage } = useFlowValidation(cmsFlow)

  const {
    phoneContainerRef,
    isFetching,
    handleRestartSimulator,
    isSimulatorThrownError,
    isFlowDataAvailable,
  } = useFlowPickerPreview({ lastSelectedFlowId, isValid, cmsFlow })

  const handlePickAutomation = useCallback(() => {
    dispatch(FlowPickerActions.setSelectedFlowId({ flowId: lastSelectedFlowId }))
  }, [dispatch, lastSelectedFlowId])

  if (isFetching) {
    return <Loader size={32} center />
  }

  if (!isValid) {
    return <div className="text-secondary text-center p-x">{errorMessage}</div>
  }

  if (!isFlowDataAvailable) return null

  return (
    <>
      <FlowPickerSimulator
        isSimulatorThrownError={isSimulatorThrownError}
        phoneContainerRef={phoneContainerRef}
        handleRestartSimulator={handleRestartSimulator}
      />
      <BtnV2
        fullWidth
        variant="primary"
        onClick={handlePickAutomation}
        className="flex-shrink-0"
        data-test-id="flow-picker-select-flow-button"
      >
        {l.translate('Pick this Automation')}
      </BtnV2>
    </>
  )
}
